export default __webpack_public_path__ + "static/media/user-default-avatar.fe75c8d0.svg";